var map = {
	"./auth-routes.js": 6509,
	"./bantuan-perkebunan-routes.js": 1143,
	"./bantuan-sphp-routes.js": 619,
	"./bantuan-ternak-routes.js": 1654,
	"./general-routes.js": 8710,
	"./inseminasi-buatan-routes.js": 7620,
	"./kebun-sumber-benih-routes.js": 7962,
	"./lalu-lintas-ternak-routes.js": 7475,
	"./master-routes.js": 5966,
	"./pemotongan-hewan-routes.js": 5313,
	"./penangkar-benih-routes.js": 7490,
	"./pengamatan-opt-routes.js": 7526,
	"./penyakit-hewan-routes.js": 3659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 981;